module.exports = __webpack_public_path__ + "img/us.9dd9a2f7.svg";